import { render } from "./loadsPrint.vue?vue&type=template&id=16877876"
import script from "./loadsPrint.vue?vue&type=script&lang=js"
export * from "./loadsPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__